import './styles.scss'; //build the styles in scss and then compiles to index.css.


function setCurrentPageLink() {
    
    const getAllLinkListItems = document.querySelectorAll('.wp-block-acf-page-link-list a')
    const currentUrl = window.location.href

        for( const link of getAllLinkListItems) {
        
            if (link.href === currentUrl) {

                link.classList.add('link--active');
            }
        }
}

document.addEventListener("DOMContentLoaded", () => { 

    setCurrentPageLink()
})